export default __webpack_public_path__ + "static/media/float icon1.5cc38683.png";